module.exports = __webpack_public_path__ + "img/menupwbaus.9f95482c.png";